import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/vant'
import './styles/index.less'

import 'amfe-flexible'
import day from './utils/day'
import "../smartcitysdk1";

import VConsole from "vconsole"



// Vue.prototype.$empty = require("@/assets/images/empty1.png")

if (process.env.NODE_ENV === "development"||process.env.NODE_ENV === "test") {

  const vConsole = new VConsole();

}

Vue.config.productionTip = false
Vue.use(day)



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
